function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'white': 'rgb(255, 255, 255)','matte-white': 'rgb(255, 255, 255)','matt-white': 'rgb(255, 255, 255)','gloss-white': 'rgb(255, 255, 255)','glacier-white': 'rgb(255, 255, 255)','black': 'rgb(0, 0, 0)','matte-black': 'rgb(0, 0, 0)','matt-black': 'rgb(0, 0, 0)','glacier-black': 'rgb(0, 0, 0)','dark-blue': 'rgb(0, 0, 90)',};

    this.images = {'chrome': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/chrome_color_68x.png?v=5361991129882292205")','gun-metal': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/gun_metal_color_68x.jpg?v=1642272978840495016")','gun-metal-grey': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/gun_metal_color_68x.jpg?v=1642272978840495016")','brushed-gold': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/brushed_gold_color_68x.png?v=17874922724759484067")','gold': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/brushed_gold_color_68x.png?v=17874922724759484067")','brushed-nickel': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/bruhed_nickel_color_68x.png?v=2025171614042260447")','brushed-bronze': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/brushed_bronze_color_68x.png?v=12604257180095493702")','chrome-black': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/chrome_black_color_68x.heic?v=15012080232716711129")','chrome-white': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/chrome_white_color_68x.heic?v=17569073439148386292")','gloss-white-matte-black': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/white_black_color_68x.heic?v=8051601987568858843")','black-rose-gold': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/black_gold_color_68x.heic?v=13996242543327465343")','marble-with-gold-edge': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/marble_gold_68x.heic?v=4669565588586453670")','marble': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/marble_color_68x.png?v=10659784413592471335")','oak': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/oak_color_68x.webp?v=10925470810199765915")','max': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/max_color_68x.png?v=12685214236449875963")','mia': 'url("//www.maxtenbathrooms.com.au/cdn/shop/files/mia_color_68x.png?v=4960834651447028307")',};

    this.triggers = ['color','colour','cabinet color','couleur','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
